import React, {Component} from 'react'
import {connect} from 'react-redux'
import { Menu, Segment } from 'semantic-ui-react'
import Icons from "../../Constants/Icons";
import RequestURLBox from "../../SharedComponents/RequestURLBox"
import {getFullAPIUrl} from "../getFullAPIUrl";
import CustomAccordion from "../../SharedComponents/CustomAccordion"
import UtilitiesCodeAccordion from "../UtilitiesCodeAccordion"
import UtilitiesCodeSnippet from "../UtilitiesCodeSnippet"
import UtilitiesSampleResponse from "../UtilitiesSampleResponse"
import JSONAccordionIndex from "../../SharedComponents/JSONAccordion/JSONAccordionIndex"
import FilesResponseParams from "../FilesResponseParams"
import ErrorResponseCodesBody from "../ErrorResponseCodesBody"
import UtilitiesFileReadIndex from "./UtilitiesFileReadIndex"
import UtilitiesFileUpdateIndex from "./UtilitiesFileUpdateIndex"
import UtilitiesFileDeleteIndex from "./UtilitiesFileDeleteIndex"

class UtilitiesFilesIndex extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            activeTab: 'files',
            queryParams: {
                page: '',
                pageSize: '',
                q: '',
                sortBy: '',
                sortOrder: '',
                createdAfter: '',
                createdBefore: ''
            },
            actualResponse: null,
            loadingResponse: false,
            responseError: null
        }
    }

    componentDidMount() {
        this.fetchActualResponse();
    }

    fetchActualResponse = async () => {
        this.setState({ loadingResponse: true, responseError: null });
        
        try {
            const { utilitiesInfo } = this.props;
            const url = getFullAPIUrl(this.props.baseURL, "files") + "?page=1&pageSize=1";
            
            const headers = {};
            if (utilitiesInfo && utilitiesInfo.keys && utilitiesInfo.keys.length > 0) {
                headers['accessKey'] = utilitiesInfo.keys[0].access_key;
                headers['secretKey'] = utilitiesInfo.keys[0].secret_key;
            }

            const response = await fetch(url, {
                method: 'GET',
                headers: headers
            });

            if (response.ok) {
                const data = await response.json();
                this.setState({ actualResponse: data, loadingResponse: false });
            } else {
                const errorData = await response.json();
                this.setState({ 
                    responseError: errorData.error || 'Failed to fetch response', 
                    loadingResponse: false 
                });
            }
        } catch (error) {
            this.setState({ 
                responseError: 'Network error: ' + error.message, 
                loadingResponse: false 
            });
        }
    }

    handleInputChange = (paramName, value) => {
        this.setState(prevState => ({
            queryParams: {
                ...prevState.queryParams,
                [paramName]: value
            }
        }))
    }

    buildQueryString = () => {
        const { queryParams } = this.state;
        const params = [];
        
        Object.keys(queryParams).forEach(key => {
            if (queryParams[key] && queryParams[key].trim() !== '') {
                params.push(`${key}=${encodeURIComponent(queryParams[key])}`);
            }
        });
        
        return params.length > 0 ? '?' + params.join('&') : '';
    }

    getFullUrl = () => {
        const baseUrl = getFullAPIUrl(this.props.baseURL, "files");
        const queryString = this.buildQueryString();
        return baseUrl + queryString;
    }

    getCodeSamples = () => {
        const url = this.getFullUrl();
        const { utilitiesInfo } = this.props;
        
        const hasAuth = utilitiesInfo && utilitiesInfo.keys && utilitiesInfo.keys.length > 0;
        const accessKey = hasAuth ? utilitiesInfo.keys[0].access_key : '<your-access-key>';
        const secretKey = hasAuth ? utilitiesInfo.keys[0].secret_key : '<your-secret-key>';

        return {
            cURL: hasAuth 
                ? `$ curl -X GET '${url}' \\\n-H "accessKey: ${accessKey}" \\\n-H "secretKey: ${secretKey}"`
                : `$ curl -X GET '${url}'`,
            python: hasAuth
                ? `# pip install requests\n\nimport requests\n\nheaders = {\n    "accessKey": "${accessKey}",\n    "secretKey": "${secretKey}"\n}\n\nr = requests.get("${url}", headers=headers)\n\nif r.status_code == 200:\n    # SUCCESS\n    resp_data = r.json()\nelse:\n    # ERROR\n    pass`
                : `# pip install requests\n\nimport requests\n\nr = requests.get("${url}")\n\nif r.status_code == 200:\n    # SUCCESS\n    resp_data = r.json()\nelse:\n    # ERROR\n    pass`,
            javascript: hasAuth
                ? `fetch("${url}", {\n    method: "GET",\n    headers: {\n        "Accept": "application/json, text/plain, */*",\n        "accessKey": "${accessKey}",\n        "secretKey": "${secretKey}"\n    }\n}).then(res => {\n    if (res.status === 200) {\n        res.json().then(data => {\n            // SUCCESS\n            const respData = data;\n        }).catch(err => console.log(err))\n    } else {\n        // ERROR\n    }\n})`
                : `fetch("${url}", {\n    method: "GET",\n    headers: {\n        "Accept": "application/json, text/plain, */*"\n    }\n}).then(res => {\n    if (res.status === 200) {\n        res.json().then(data => {\n            // SUCCESS\n            const respData = data;\n        }).catch(err => console.log(err))\n    } else {\n        // ERROR\n    }\n})`,
            ruby: hasAuth
                ? `require 'net/http'\nrequire 'json'\n\nurl = "${url}"\nuri = URI.parse(url)\n\nhttp = Net::HTTP.new(uri.host, uri.port)\nrequest = Net::HTTP::Get.new(uri.request_uri)\nrequest['accessKey'] = '${accessKey}'\nrequest['secretKey'] = '${secretKey}'\n\nresponse = http.request(request)\nif response.code == '200'\n    # SUCCESS\n    resp_data = JSON.parse(response.body)\nelse\n    # ERROR\nend`
                : `require 'net/http'\nrequire 'json'\n\nurl = "${url}"\nuri = URI.parse(url)\n\nhttp = Net::HTTP.new(uri.host, uri.port)\nrequest = Net::HTTP::Get.new(uri.request_uri)\n\nresponse = http.request(request)\nif response.code == '200'\n    # SUCCESS\n    resp_data = JSON.parse(response.body)\nelse\n    # ERROR\nend`,
            PHP: hasAuth
                ? `<?php\n$url = "${url}";\n\n$curl = curl_init($url);\ncurl_setopt($curl, CURLOPT_HEADER, false);\ncurl_setopt($curl, CURLOPT_RETURNTRANSFER, true);\ncurl_setopt($curl, CURLOPT_HTTPHEADER, array(\n    "accessKey: ${accessKey}",\n    "secretKey: ${secretKey}"\n));\ncurl_setopt($curl, CURLOPT_HTTPGET, true);\n\n$json_response = curl_exec($curl);\n\n$status = curl_getinfo($curl, CURLINFO_HTTP_CODE);\n\nif ($status == 200) {\n    // SUCCESS\n    $resp_data = json_decode($json_response, true);\n} else {\n    // ERROR\n}\n\ncurl_close($curl);\n?>`
                : `<?php\n$url = "${url}";\n\n$curl = curl_init($url);\ncurl_setopt($curl, CURLOPT_HEADER, false);\ncurl_setopt($curl, CURLOPT_RETURNTRANSFER, true);\ncurl_setopt($curl, CURLOPT_HTTPGET, true);\n\n$json_response = curl_exec($curl);\n\n$status = curl_getinfo($curl, CURLINFO_HTTP_CODE);\n\nif ($status == 200) {\n    // SUCCESS\n    $resp_data = json_decode($json_response, true);\n} else {\n    // ERROR\n}\n\ncurl_close($curl);\n?>`
        };
    }

    handleTabChange = (tabName) => {
        this.setState({ activeTab: tabName });
    }

    renderTabs = () => {
        const { activeTab } = this.state;
        
        const tabs = [
            { id: 'files', label: 'Files', icon: 'folder' },
            { id: 'read', label: 'Read', icon: Icons.readAction },
            { id: 'update', label: 'Update', icon: Icons.updateAction },
            { id: 'delete', label: 'Delete', icon: Icons.deleteAction }
        ];

        return (
            <Menu pointing secondary>
                {tabs.map(tab => (
                    <Menu.Item
                        key={tab.id}
                        icon={tab.icon}
                        name={tab.label}
                        active={activeTab === tab.id}
                        onClick={() => this.handleTabChange(tab.id)}
                        style={{
                            color: activeTab === tab.id ? "#28a745" : "#6c757d",
                            fontSize: "14px"
                        }}
                    />
                ))}
            </Menu>
        );
    }

    renderFilesTab = () => {
        const { queryParams, actualResponse, loadingResponse, responseError } = this.state;
        const fullUrl = this.getFullUrl();

        const queryParametersContent = (
            <div style={{ padding: "16px" }}>
                <div style={{ marginBottom: "20px" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "8px" }}>
                        <div style={{ flex: 1 }}>
                            <h4 style={{ margin: "0 0 4px 0", fontSize: "14px", fontWeight: "600", color: "#333" }}>
                                page
                            </h4>
                            <p style={{ margin: "0 0 4px 0", fontSize: "12px", color: "#666" }}>
                                <strong>Type:</strong> integer | <strong>Constraints:</strong> ≥ 1 | <strong>Default:</strong> 1
                            </p>
                            <p style={{ margin: "0 0 8px 0", fontSize: "12px", color: "#666" }}>
                                Page number (1-indexed).
                            </p>
                        </div>
                        <input
                            type="number"
                            min="1"
                            value={queryParams.page}
                            onChange={(e) => this.handleInputChange('page', e.target.value)}
                            style={{
                                width: "120px",
                                padding: "6px 8px",
                                border: "1px solid #ddd",
                                borderRadius: "4px",
                                fontSize: "12px"
                            }}
                        />
                    </div>
                </div>

                <div style={{ marginBottom: "20px" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "8px" }}>
                        <div style={{ flex: 1 }}>
                            <h4 style={{ margin: "0 0 4px 0", fontSize: "14px", fontWeight: "600", color: "#333" }}>
                                pageSize
                            </h4>
                            <p style={{ margin: "0 0 4px 0", fontSize: "12px", color: "#666" }}>
                                <strong>Type:</strong> integer | <strong>Constraints:</strong> 1 to 200 | <strong>Default:</strong> 50
                            </p>
                            <p style={{ margin: "0 0 8px 0", fontSize: "12px", color: "#666" }}>
                                Page size.
                            </p>
                        </div>
                        <input
                            type="number"
                            min="1"
                            max="200"
                            value={queryParams.pageSize}
                            onChange={(e) => this.handleInputChange('pageSize', e.target.value)}
                            style={{
                                width: "120px",
                                padding: "6px 8px",
                                border: "1px solid #ddd",
                                borderRadius: "4px",
                                fontSize: "12px"
                            }}
                        />
                    </div>
                </div>

                <div style={{ marginBottom: "20px" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "8px" }}>
                        <div style={{ flex: 1 }}>
                            <h4 style={{ margin: "0 0 4px 0", fontSize: "14px", fontWeight: "600", color: "#333" }}>
                                q
                            </h4>
                            <p style={{ margin: "0 0 4px 0", fontSize: "12px", color: "#666" }}>
                                <strong>Type:</strong> string
                            </p>
                            <p style={{ margin: "0 0 8px 0", fontSize: "12px", color: "#666" }}>
                                Full-text search across file name and description.
                            </p>
                        </div>
                        <input
                            type="text"
                            value={queryParams.q}
                            onChange={(e) => this.handleInputChange('q', e.target.value)}
                            placeholder="Search files..."
                            style={{
                                width: "120px",
                                padding: "6px 8px",
                                border: "1px solid #ddd",
                                borderRadius: "4px",
                                fontSize: "12px"
                            }}
                        />
                    </div>
                </div>

                <div style={{ marginBottom: "20px" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "8px" }}>
                        <div style={{ flex: 1 }}>
                            <h4 style={{ margin: "0 0 4px 0", fontSize: "14px", fontWeight: "600", color: "#333" }}>
                                sortBy
                            </h4>
                            <p style={{ margin: "0 0 4px 0", fontSize: "12px", color: "#666" }}>
                                <strong>Type:</strong> string enum | <strong>Default:</strong> createdDt
                            </p>
                            <p style={{ margin: "0 0 8px 0", fontSize: "12px", color: "#666" }}>
                                Sort field.
                            </p>
                            <div style={{ display: "flex", gap: "4px", flexWrap: "wrap" }}>
                                {['createdDt', 'updatedDt', 'name', 'size'].map(option => (
                                    <span
                                        key={option}
                                        style={{
                                            padding: "2px 6px",
                                            backgroundColor: queryParams.sortBy === option ? "#007bff" : "#f8f9fa",
                                            color: queryParams.sortBy === option ? "white" : "#666",
                                            borderRadius: "4px",
                                            fontSize: "10px",
                                            cursor: "pointer",
                                            border: "1px solid #ddd"
                                        }}
                                        onClick={() => this.handleInputChange('sortBy', option)}
                                    >
                                        {option}
                                    </span>
                                ))}
                            </div>
                        </div>
                        <select
                            value={queryParams.sortBy}
                            onChange={(e) => this.handleInputChange('sortBy', e.target.value)}
                            style={{
                                width: "120px",
                                padding: "6px 8px",
                                border: "1px solid #ddd",
                                borderRadius: "4px",
                                fontSize: "12px"
                            }}
                        >
                            <option value="">Select...</option>
                            <option value="createdDt">createdDt</option>
                            <option value="updatedDt">updatedDt</option>
                            <option value="name">name</option>
                            <option value="size">size</option>
                        </select>
                    </div>
                </div>

                <div style={{ marginBottom: "20px" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "8px" }}>
                        <div style={{ flex: 1 }}>
                            <h4 style={{ margin: "0 0 4px 0", fontSize: "14px", fontWeight: "600", color: "#333" }}>
                                sortOrder
                            </h4>
                            <p style={{ margin: "0 0 4px 0", fontSize: "12px", color: "#666" }}>
                                <strong>Type:</strong> string enum | <strong>Default:</strong> desc
                            </p>
                            <p style={{ margin: "0 0 8px 0", fontSize: "12px", color: "#666" }}>
                                Sort order.
                            </p>
                            <div style={{ display: "flex", gap: "4px", flexWrap: "wrap" }}>
                                {['asc', 'desc'].map(option => (
                                    <span
                                        key={option}
                                        style={{
                                            padding: "2px 6px",
                                            backgroundColor: queryParams.sortOrder === option ? "#007bff" : "#f8f9fa",
                                            color: queryParams.sortOrder === option ? "white" : "#666",
                                            borderRadius: "4px",
                                            fontSize: "10px",
                                            cursor: "pointer",
                                            border: "1px solid #ddd"
                                        }}
                                        onClick={() => this.handleInputChange('sortOrder', option)}
                                    >
                                        {option}
                                    </span>
                                ))}
                            </div>
                        </div>
                        <select
                            value={queryParams.sortOrder}
                            onChange={(e) => this.handleInputChange('sortOrder', e.target.value)}
                            style={{
                                width: "120px",
                                padding: "6px 8px",
                                border: "1px solid #ddd",
                                borderRadius: "4px",
                                fontSize: "12px"
                            }}
                        >
                            <option value="">Select...</option>
                            <option value="asc">asc</option>
                            <option value="desc">desc</option>
                        </select>
                    </div>
                </div>

                <div style={{ marginBottom: "20px" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "8px" }}>
                        <div style={{ flex: 1 }}>
                            <h4 style={{ margin: "0 0 4px 0", fontSize: "14px", fontWeight: "600", color: "#333" }}>
                                createdAfter
                            </h4>
                            <p style={{ margin: "0 0 4px 0", fontSize: "12px", color: "#666" }}>
                                <strong>Type:</strong> date-time
                            </p>
                            <p style={{ margin: "0 0 8px 0", fontSize: "12px", color: "#666" }}>
                                Filter files created after this date.
                            </p>
                        </div>
                        <input
                            type="datetime-local"
                            value={queryParams.createdAfter}
                            onChange={(e) => this.handleInputChange('createdAfter', e.target.value)}
                            style={{
                                width: "120px",
                                padding: "6px 8px",
                                border: "1px solid #ddd",
                                borderRadius: "4px",
                                fontSize: "12px"
                            }}
                        />
                    </div>
                </div>

                <div style={{ marginBottom: "20px" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "8px" }}>
                        <div style={{ flex: 1 }}>
                            <h4 style={{ margin: "0 0 4px 0", fontSize: "14px", fontWeight: "600", color: "#333" }}>
                                createdBefore
                            </h4>
                            <p style={{ margin: "0 0 4px 0", fontSize: "12px", color: "#666" }}>
                                <strong>Type:</strong> date-time
                            </p>
                            <p style={{ margin: "0 0 8px 0", fontSize: "12px", color: "#666" }}>
                                Filter files created before this date.
                            </p>
                        </div>
                        <input
                            type="datetime-local"
                            value={queryParams.createdBefore}
                            onChange={(e) => this.handleInputChange('createdBefore', e.target.value)}
                            style={{
                                width: "120px",
                                padding: "6px 8px",
                                border: "1px solid #ddd",
                                borderRadius: "4px",
                                fontSize: "12px"
                            }}
                        />
                    </div>
                </div>

                <div style={{ marginTop: "20px", textAlign: "center" }}>
                    <button
                        onClick={() => this.setState({ queryParams: { page: '', pageSize: '', q: '', sortBy: '', sortOrder: '', createdAfter: '', createdBefore: '' } })}
                        style={{
                            padding: "8px 16px",
                            backgroundColor: "#f8f9fa",
                            border: "1px solid #ddd",
                            borderRadius: "4px",
                            cursor: "pointer",
                            fontSize: "12px"
                        }}
                    >
                        Clear All
                    </button>
                </div>
            </div>
        );

        return (
            <div>
                <div style={{ marginBottom: "24px"}}>
                    <RequestURLBox url={fullUrl} />
                </div>
                <div style={{ marginBottom: "24px"}}>
                    <CustomAccordion
                        body={queryParametersContent}
                        header="Query Parameters"
                        accordionStyle={{
                            borderRadius: '4px',
                            border: "1px solid #F0F0F0",
                            backgroundColor: 'white'
                        }}
                        headerDivStyle={{
                            borderRadius: '4px',
                            backgroundColor: 'white',
                            fontSize: '16px',
                            fontWeight: '700',
                            fontFamily: "Lato",
                            padding: "16px"
                        }}
                    />
                </div>
                <div style={{ marginBottom: "24px"}}>
                    <CustomAccordion
                        body={
                            <div>
                                <UtilitiesCodeSnippet code={this.getCodeSamples()} height={150} />
                            </div>
                        }
                        header="Code Samples"
                        accordionStyle={{
                            borderRadius: '4px',
                            border: "1px solid #F0F0F0",
                            backgroundColor: 'white'
                        }}
                        headerDivStyle={{
                            borderRadius: '4px',
                            backgroundColor: 'white',
                            fontSize: '16px',
                            fontWeight: '700',
                            fontFamily: "Lato",
                            padding: "16px"
                        }}
                        open
                    />
                </div>
                <div style={{ marginBottom: "24px"}}>
                    <div className="row">
                        <div className="col-sm-6">
                            <JSONAccordionIndex
                                title="Sample Response Body"
                                message=""
                                heading=""
                                jsonObj={actualResponse || {}}
                            />
                        </div>
                        <div className="col-sm-6">
                            <CustomAccordion
                                body={<div>
                                    {loadingResponse ? (
                                        <div style={{ padding: "20px", textAlign: "center" }}>
                                            <div>Loading actual response...</div>
                                        </div>
                                    ) : responseError ? (
                                        <div style={{ padding: "20px", color: "#dc3545" }}>
                                            <div><strong>Error:</strong> {responseError}</div>
                                            <button 
                                                onClick={this.fetchActualResponse}
                                                style={{
                                                    marginTop: "10px",
                                                    padding: "8px 16px",
                                                    backgroundColor: "#007bff",
                                                    color: "white",
                                                    border: "none",
                                                    borderRadius: "4px",
                                                    cursor: "pointer"
                                                }}
                                            >
                                                Retry
                                            </button>
                                        </div>
                                    ) : (
                                        <div style={{ fontSize: "14px", color: "#666", marginBottom: "24px" }}>
                                            A successful request will return a <code style={{ color: "#333", fontWeight: "700"}}>200 response code</code> and the following parameters
                                        </div>
                                    )}
                                    <FilesResponseParams />
                                </div>}
                                header="Response Body Parameters"
                                accordionStyle={{
                                    borderRadius: '4px',
                                    border: "1px solid #F0F0F0",
                                    backgroundColor: 'white'
                                }}
                                headerDivStyle={{
                                    borderRadius: '4px',
                                    backgroundColor: 'white',
                                    fontSize: '16px',
                                    fontWeight: '700',
                                    fontFamily: "Lato",
                                    padding: "16px"
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div style={{ marginTop: "24px"}}>
                    <CustomAccordion
                        body={<ErrorResponseCodesBody
                            mode="files"
                        />}
                        header="Error Response Codes and Messages"
                        accordionStyle={{
                            borderRadius: '4px',
                            border: "1px solid #F0F0F0",
                            backgroundColor: 'white'
                        }}
                        headerDivStyle={{
                            borderRadius: '4px',
                            backgroundColor: 'white',
                            fontSize: '16px',
                            fontWeight: '700',
                            fontFamily: "Lato",
                            padding: "16px"
                        }}
                    />
                </div>
            </div>
        );
    }

    renderTabContent = () => {
        const { activeTab } = this.state;

        switch (activeTab) {
            case 'files':
                return this.renderFilesTab();
            case 'read':
                return <UtilitiesFileReadIndex {...this.props} />;
            case 'update':
                return <UtilitiesFileUpdateIndex {...this.props} />;
            case 'delete':
                return <UtilitiesFileDeleteIndex {...this.props} />;
            default:
                return this.renderFilesTab();
        }
    }

    render() {
        return (
            <div>
                {this.renderTabs()}
                {this.renderTabContent()}
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    utilitiesInfo: state.mainState.utilitiesInfo
})

const mapActionsToProps = {}

export default connect(mapStateToProps, mapActionsToProps)(UtilitiesFilesIndex)
